import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Fahrplan',
  moduleId: MODULE_ID,
  api: 'fahrplan',

  routeHandler,
};

export default module;
